import React from "react";
import styled from "@emotion/styled";
import { Button } from "@mui/material";

import { START_NEW_CHAT } from "../../constants/footer";
import IconGrid from "./IconGrid.jsx";

const FooterContainer = styled.div(({ theme, maxWidth }) => ({
  display: "flex",
  backgroundColor: theme.colors.brandWhite,
  height: "8%",
  padding: "0 1rem",
  justifyContent: "space-between",
  alignItems: "center",
  "& *": {
    fontFamily: theme.fonts.plutoRegular,
  },
}));

// const AiAgentDropDown = styled(Autocomplete)(({ theme }) => ({
const AiAgentDropDown = styled.select(({ theme }) => ({
  height: "60%",
  width: "12%",
  padding: "0 0.5rem",
  // ! Will be reverted back to Autocomplete when the feature is ready
  // "& .MuiAutocomplete-inputRoot": {
  //   backgroundColor: theme.colors.brandWhite,
  //   padding: "0 0.5rem",
  // },
  // "& .MuiAutocomplete-input": {
  //   color: theme.colors.brandBlack,
  // },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  height: "55%",
  color: theme.colors.brandBlack,
  backgroundColor: theme.colors.brandWhite,
  textTransform: "capitalize",
  border: `1px solid ${theme.colors.brandBlack38}`,
  fontSize: "0.8rem",
  fontFamily: theme.fonts.plutoRegular,
  padding: "0 0.5rem",
  "&:hover": {
    backgroundColor: theme.colors.brandRed,
  },
}));

export const Footer = ({ children, resetChat }) => {
  return (
    <FooterContainer>
      {children}
      <AiAgentDropDown
        onChange={(event, value) => {
          // TODO Do nothing for now
        }}
        disabled
      >
        <option value="Gemini">Gemini</option>
      </AiAgentDropDown>
      <StyledButton
        onClick={() => {
          resetChat();
        }}
      >
        {START_NEW_CHAT}
      </StyledButton>
      <IconGrid />
    </FooterContainer>
  );
};
